// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-normal';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import Parts, {getDefaultState as getPartsDefaultState} from '../../shared/state/parts';
import Pin, {getDefaultState as getPinDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pin';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../../src/claim/shared/state/warranty-status-modal';
import t from 'tcomb';

const NormalClaim = t.struct({
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    failureModes: KeyValuePairCollection,
    formValidation: FormValidation,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isNonTrackedPinModalVisible: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    isValidClaim: t.Boolean,
    parts: Parts,
    pin: Pin,
    product: Product,
    showApplyTravel: t.Boolean,
    temporaryObjectKey: t.String,
    updateShowApplyTravel: t.Boolean,
    warrantyStatusModal: WarrantyStatusModal
}, 'NormalClaim');

export const getDefaultState = () =>
    new NormalClaim({
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        customer: getCustomerDefaultState(),
        failureModes: getDefaultKeyValueCollection(),
        formValidation: getDefaultFormValidationState(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isNonTrackedPinModalVisible: false,
        isStickyHeaderVisible: false,
        isValidClaim: false,
        parts: getPartsDefaultState(),
        pin: getPinDefaultState(),
        product: getProductDefaultState(),
        showApplyTravel: false,
        temporaryObjectKey: '',
        updateShowApplyTravel: false,
        warrantyStatusModal: getWarrantyStatusModal()
    });

export default NormalClaim;



// WEBPACK FOOTER //
// ./src/claim/normal/state/index.js